import projectsList from './modules/store'

export const modules = {
  projectsList
}



// WEBPACK FOOTER //
// ./src/store/Projects/index.js